export default [
  'GF',
  'RC',
  'AB',
  'JD',
  'KG'
]
